export default __webpack_public_path__ + "static/media/Manisha Pathak.a55be751.jpg";